import {
	FC,
	Children,
	cloneElement,
	isValidElement,
	ReactElement,
	useState,
} from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import Box from "../../layout/boxes/Box";

import AccordionItem from "./AccordionItem/AccordionItem";
import AccordionTitle from "./AccordionTitle/AccordionTitle";
import AccordionContent from "./AccordionContent/AccordionContent";

import { AccordionProps, AccordionSubComponents } from "./Accordion.types";
import { AccordionItemProps } from "./AccordionItem/AccordionItem.types";

const Accordion: FC<AccordionProps> & AccordionSubComponents = ({
	className,
	children,
	colorOn,
	grouped = false,
	indexOpened,
}) => {
	const [activeItemIndex, setActiveItemIndex] = useState(indexOpened);

	const block = new BemIt("Accordion");

	const accordionItems = Children.map(children, (child, index) => {
		if (isValidElement(child)) {
			const isItem = child.type === AccordionItem;

			if (!isItem) {
				console.error(
					`Invalid Accordion subcomponent: The child you provided is not a valid Accordion subcomponent, please provide Accordion.Item subcomponent`
				);
				return null;
			}

			return (
				isValidElement(child) &&
				cloneElement(child as ReactElement<AccordionItemProps>, {
					colorOn,
					...(grouped && {
						isOpen: activeItemIndex === index,
						onToggle: () => setActiveItemIndex(index),
					}),
				})
			);
		}
	});

	return (
		<Box className={addClass(className).after(block)}>{accordionItems}</Box>
	);
};

Accordion.Item = AccordionItem;
Accordion.Title = AccordionTitle;
Accordion.Content = AccordionContent;

export default Accordion;
